export const COLORS = {
  Green: '#95d6be',
  White: '#ffffff',
  Blue: '#6672fb',
  Brown: '#6d2e46',
  Yellow: '#f8b849',
  Red: '#ff3d55',
  DarkBlue: '#2a2153',
};
